import { useState } from 'react';
import axios from 'axios';
import { CONTACT_ENDPOINTS } from '../constants/api';

interface ContactFormData {
  name: string;
  surname: string;
  email: string;
  message: string;
}

interface UseContactFormResult {
  submitContactForm: (formData: ContactFormData) => Promise<{ success: boolean; error?: string }>;
  submitting: boolean;
  submitted: boolean;
  error: string;
  resetForm: () => void;
}

export const useContactForm = (): UseContactFormResult => {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const submitContactForm = async (formData: ContactFormData) => {
    setError('');
    setSubmitting(true);

    try {
      const response = await axios.post(CONTACT_ENDPOINTS.SUBMIT, {
        name: formData.name,
        surname: formData.surname,
        email: formData.email,
        message: formData.message
      });

      if (response.data.success) {
        setSubmitted(true);
        return { success: true };
      }

      return { success: false, error: 'Submission failed' };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Failed to send message. Please try again later.';
      setError(errorMessage);
      console.error('Contact form submission error:', err);
      return { success: false, error: errorMessage };
    } finally {
      setSubmitting(false);
    }
  };

  const resetForm = () => {
    setSubmitted(false);
    setError('');
  };

  return {
    submitContactForm,
    submitting,
    submitted,
    error,
    resetForm
  };
};
